/**
 * A white card holding a table or list: title (with an optional count), subtitle, a toolbar on the right (search,
 * filters, kebab) and the body. `Table` is the kit's table shell. `pager`: the list's Pager, on the card's bottom edge.
 * A text subtitle explains the card, so it sits behind the title's "i" (owner rule, 16 Oct 2026: the screen shows only
 * what a person acts on); a subtitle that is a node (it carries its own controls) is drawn under the title as before.
 */
import React from 'react';
import InfoHint from './InfoHint';

export default function DataCard({ title, count, subtitle, tools, children, footer, pager, testId, id }) {
  const headingId = id || (typeof title === 'string' ? `cu-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : undefined);
  return (
    <section className="cu-card" aria-labelledby={headingId} data-testid={testId}>
      {(title || tools) && (
        <div className="cu-card-head">
          <div className="cu-card-heading">
            {title ? <h2 className="cu-card-title" id={headingId}>{title}{count !== undefined && count !== null ? ` (${count})` : ''}</h2> : null}
            {typeof subtitle === 'string' && subtitle
              ? <InfoHint label={`About ${typeof title === 'string' ? title : 'this list'}`} testId={testId ? `${testId}-about` : undefined}>{subtitle}</InfoHint>
              : subtitle ? <div className="cu-card-sub">{subtitle}</div> : null}
          </div>
          {tools ? <div className="cu-card-tools">{tools}</div> : null}
        </div>
      )}
      {children}
      {pager || null}
      {footer ? <div className="cu-pad">{footer}</div> : null}
    </section>
  );
}

export function Table({ columns, children, compact = false, testId, empty }) {
  return (
    <div className="cu-table-wrap">
      <table className={`cu-table${compact ? ' cu-table--compact' : ''}`} data-testid={testId}>
        <thead>
          <tr>{columns.map((c, i) => <th key={i} scope="col" style={c.width ? { width: c.width } : undefined}>{c.title}</th>)}</tr>
        </thead>
        <tbody>
          {children}
          {empty ? <tr><td colSpan={columns.length} className="cu-empty">{empty}</td></tr> : null}
        </tbody>
      </table>
    </div>
  );
}
